import React, { useState } from 'react';
import { Button, Container, Divider, FormControl, FormLabel, Input, Stack, Typography } from '@mui/joy';
import { useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';

const Login = () => {
    const { signIn, signInWithGoogle } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await signIn(email, password);
            navigate('/');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSignIn = async () => {
        setError(null);
        setGoogleLoading(true);
        try {
            await signInWithGoogle();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Google sign-in failed');
            setGoogleLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Typography level="h2" mb={2}>
                Log In
            </Typography>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <FormControl>
                        <FormLabel>Email</FormLabel>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Password</FormLabel>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </FormControl>
                    {error && (
                        <Typography color="danger" level="body-sm">
                            {error}
                        </Typography>
                    )}
                    <Button type="submit" loading={loading}>
                        Log In
                    </Button>
                    <Button variant="plain" onClick={() => navigate('/signup')}>
                        Don't have an account? Sign up
                    </Button>
                    <Divider>or</Divider>
                    <Button variant="outlined" color="neutral" loading={googleLoading} onClick={handleGoogleSignIn}>
                        Sign in with Google
                    </Button>
                </Stack>
            </form>
        </Container>
    );
};

export default Login;
